import { cap } from '../../../State'
import { translations } from '../../../translations'

const language = cap.language.state || 'IT'
const t = translations[language]

const TONE_OPTIONS = [
  { key: 'informale', label: t.informale },
  { key: 'formale', label: t.formale },
  { key: 'molto', label: t.moltoFormale }
]

const StepChooseFormalita = ({ selectedTone: [selectedTone, setSelectedTone] }) => (
  <div className="nsec">
    <div className="nsec__head">
      <div className="nsec__ico">
        <i className="pi pi-envelope" style={{ fontSize: 16 }} />
      </div>
      <h3 className="nsec__title">{t.tonoEmail}</h3>
    </div>
    <div className="nsec__body">
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        {TONE_OPTIONS.map(({ key, label }) => (
          <button
            key={key}
            type="button"
            className={`npill ${selectedTone === key ? 'is-active' : ''}`}
            onClick={() => setSelectedTone(key)}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  </div>
)

export default StepChooseFormalita
